module.exports = __webpack_public_path__ + "static/media/bcc58842-a5b2-4deb-8169-625d6408079d_1.a0556f3f282cd9f1bdf3cc181cf4d18a.71cc2bc7.jpeg";